var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"errors"},[_vm._l((_vm.errors),function(error){return [_c('STErrorBox',{key:error.id},[_vm._v("\n            "+_vm._s(_vm.getErrorMessage(error))+"\n        ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }